// IELTS Mock 4 — Listening (IELTS Fever Listening Practice Test 7)
// Same shape as IELTS_DATA_LISTENING in ../IeltsListening.js (4 parts, 40 questions,
// one audio track that plays once straight through).
// Groups with `optionsBox` show a text box of lettered options instead of an image.
// No `audioStart` timings yet, so the page doesn't auto-scroll between Parts.

const AUDIO_SRC = "/audio/ielts_listening4.mp3";

const IELTS_MOCK4_LISTENING = {
  title: "IELTS Listening Mock 4",
  sections: [
    {
      id: "s1",
      title: "Section 1: Hotel Booking Enquiry",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 1–10: Complete the form below. Write NO MORE THAN TWO WORDS AND/OR A NUMBER for each answer.",
          heading: "Hotel Booking Enquiry",
          example: { q: "Destination: Vancouver" },
          image: null,
          questions: [
            { id: "q1", text: "Hotel Name: Holiday ______", type: "fill_blank", answer: ["chilcotin"] },
            { id: "q2", text: "Site: near a ______", type: "fill_blank", answer: ["train station"] },
            { id: "q3", text: "Price: $ ______", type: "fill_blank", answer: ["169", "$169", "169 dollars"] },
            { id: "q4", text: "Length of stay: 5 days. Price included a free ______", type: "fill_blank", answer: ["breakfast"] },
            { id: "q5", text: "Can visit a ______ museum nearby", type: "fill_blank", answer: ["science"] },
            { id: "q6", text: "Go cycling — Bikes can be hired. Should bring ______", type: "fill_blank", answer: ["boots"] },
            { id: "q7", text: "Mountain climbing — fire is banned. Can go ______", type: "fill_blank", answer: ["fishing"] },
            { id: "q8", text: "Mountain climbing — can sleep in a ______", type: "fill_blank", answer: ["tent"] },
            { id: "q9", text: "Go hiking — if lucky, visitors can see ______ in the forest", type: "fill_blank", answer: ["black bears", "black bear", "bears", "bear"] },
            { id: "q10", text: "Go hiking — can also go on a trip to an old ______", type: "fill_blank", answer: ["gold mine", "goldmine"] },
          ],
        },
      ],
    },

    {
      id: "s2",
      title: "Section 2: Introduction to Cycling Holidays",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 11–16: What does the organiser tell the members about who should do each of the following tasks? Write the correct letter, A, B or C, next to Questions 11–16.",
          image: null,
          optionsBox: [
            "A. All the members must do it.",
            "B. Members have the option of doing it.",
            "C. The organiser is responsible for doing it.",
          ],
          mapOptions: ["A", "B", "C"],
          questions: [
            { id: "q11", text: "Taking tents", type: "map", answer: "A" },
            { id: "q12", text: "Booking campsites", type: "map", answer: "B" },
            { id: "q13", text: "Taking bicycles", type: "map", answer: "A" },
            { id: "q14", text: "Buying train tickets", type: "map", answer: "C" },
            { id: "q15", text: "Buying tickets for a football match", type: "map", answer: "B" },
            { id: "q16", text: "Collecting information about the area of the tour", type: "map", answer: "C" },
          ],
        },
        {
          instruction:
            "Questions 17–20: Which location has the following attraction? Choose FOUR answers from the box and write the correct letter, A–H, next to Questions 17–20.",
          image: null,
          optionsBox: [
            "A. farming museum",
            "B. horse riding",
            "C. locally produced food",
            "D. market selling clothes",
            "E. old ruins",
            "F. steam railway",
            "G. transport museum",
            "H. water sports",
          ],
          mapOptions: ["A", "B", "C", "D", "E", "F", "G", "H"],
          questions: [
            { id: "q17", text: "St. Andrews", type: "map", answer: "E" },
            { id: "q18", text: "Cluny", type: "map", answer: "A" },
            { id: "q19", text: "Pennerley", type: "map", answer: "C" },
            { id: "q20", text: "Farlow", type: "map", answer: "G" },
          ],
        },
      ],
    },

    {
      id: "s3",
      title: "Section 3: Pacific Tapa Cloth",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Questions 21–24: Choose the correct letter, A, B or C.",
          image: null,
          questions: [
            {
              id: "q21",
              text: "Pacific tapa cloth is different from other types of tapa cloth because it is",
              type: "mcq",
              options: [
                "A. The only tapa made today.",
                "B. Better quality than others.",
                "C. Used by a wider range of users.",
              ],
              answer: "C",
            },
            {
              id: "q22",
              text: "What does Helen say about the paper mulberry tree?",
              type: "mcq",
              options: [
                "A. It is also a source of food.",
                "B. It is not native to the Pacific.",
                "C. It can grow in any environment.",
              ],
              answer: "B",
            },
            {
              id: "q23",
              text: "Why did the Maori people of New Zealand stop making tapa?",
              type: "mcq",
              options: [
                "A. They could not find the right trees in New Zealand.",
                "B. They were introduced to other fabrics by the Europeans.",
                "C. They found a better material for making fabric.",
              ],
              answer: "C",
            },
            {
              id: "q24",
              text: "Large pieces of tapa are made from smaller pieces which are",
              type: "mcq",
              options: ["A. Stuck together", "B. Woven together", "C. Sewn together"],
              answer: "A",
            },
          ],
        },
        {
          instruction:
            "Questions 25–30: According to the speaker, what function has tapa played in the following countries? Write the correct letter, A, B, C or D, next to Questions 25–30.",
          heading: "Functions",
          image: null,
          optionsBox: ["A. Recreational", "B. Practical", "C. Spiritual", "D. Commercial"],
          mapOptions: ["A", "B", "C", "D"],
          questions: [
            { id: "q25", text: "Samoa", type: "map", answer: "C" },
            { id: "q26", text: "Tonga", type: "map", answer: "B" },
            { id: "q27", text: "Cook Islands", type: "map", answer: "C" },
            { id: "q28", text: "Fiji", type: "map", answer: "D" },
            { id: "q29", text: "Tahiti", type: "map", answer: "A" },
            { id: "q30", text: "Tikopia", type: "map", answer: "B" },
          ],
        },
      ],
    },

    {
      id: "s4",
      title: "Section 4: Monarch Butterflies",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 31–40: Complete the notes below. Write NO MORE THAN TWO WORDS AND/OR A NUMBER for each answer.",
          heading: "Monarch Butterflies",
          image: null,
          questions: [
            { id: "q31", text: "Hibernation — Butterflies named 'Banded Hair Freak' hibernate in the form of an ______", type: "fill_blank", answer: ["egg", "an egg"] },
            { id: "q32", text: "Hibernation — A species called 'Dapple White' accumulates ______ from larval stage.", type: "fill_blank", answer: ["energy"] },
            { id: "q33", text: "Hibernation — A substance is produced in the blood which may function as ______", type: "fill_blank", answer: ["anti-freeze", "antifreeze", "anti freeze", "extra resistance"] },
            { id: "q34", text: "Hibernation — There are few predators because they can only survive in ______ weather.", type: "fill_blank", answer: ["warm"] },
            { id: "q35", text: "Migration — Monarch butterflies move to ______ in winter.", type: "fill_blank", answer: ["north america"] },
            { id: "q36", text: "Migration — The survival skill can help them last for up to ______ during a long journey.", type: "fill_blank", answer: ["6 months", "six months"] },
            { id: "q37", text: "Migration — Monarch butterflies fly in the daytime and stay in ______ during night.", type: "fill_blank", answer: ["trees", "tree"] },
            { id: "q38", text: "Migration — Researchers found out that they orient by flying along the ______", type: "fill_blank", answer: ["rivers", "river"] },
            { id: "q39", text: "Migration — They also follow the direction of the ______ for navigational aid.", type: "fill_blank", answer: ["sun"] },
            { id: "q40", text: "Migration — Recently the annual arrival of the monarchs can be a good interest to ______ in the region.", type: "fill_blank", answer: ["tourists", "tourist"] },
          ],
        },
      ],
    },
  ],
};

export default IELTS_MOCK4_LISTENING;
